import { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import Select from "react-select";
import { decryptData, defaulUrl, Loading } from "../components/const";
const ModalSendSms = ({ clients }) => {
    const [isloading, setIsLoading] = useState(false)
    const ref = useRef();
    const [sms, setSms] = useState(null)
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [tous, setTous] = useState(false)
    const [contacts, setContacts] = useState([]);

    const sendCostunMessage = (e) => {
        e.preventDefault()
        if (!tous && selectedOptions.length < 1) {
            Swal.fire({

                title: "Aucun contact ajouté",
                text: "Veuillez ajouter au moins un contact",
                icon: "error"
            })
            return
        }
        if (!sms) {
            Swal.fire({

                title: "Envoi impossible",
                text: "Impossible d'envoyer un message vide!",
                icon: "error"
            })
            return
        }
        let status = 0;
        setIsLoading(true)
        fetch(`${defaulUrl}message/costum`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`,
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                "message": sms,
                contacts
            })
        }).then(response => {
            status = response.status;
            return response.json()
        }).then(data => {
            setIsLoading(false)
            if (status === 200) {
                Swal.fire({
                    title: "Messages envoyés",
                    text: data?.message,
                    icon: 'success'

                })
            } else {
                Swal.fire({
                    title: "Messages non envoyés",
                    text: data?.error,
                    icon: 'error'

                })
            }
        })
    }
    useEffect(() => {
        setContacts(selectedOptions.map((clt) => (clt.value)))
    }, [selectedOptions])
    useEffect(() => {
        if (tous) {
            setContacts(clients.map((clt) => (clt.telephone)))
        } else {
            setContacts(selectedOptions.map((clt) => (clt.value)))
        }
    }, [tous])
    return (
        <div className="modal modal-lg fade " id="modal-envoi" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header bg-secondary-subtle">
                        <h1 className="modal-title fs-5" >Envoyer un message</h1>
                        <button type="button " className="btn-close btn-danger" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form onSubmit={(e) => sendCostunMessage(e)} >
                        <div className="modal-body position-relative">
                            <div className="form-group my-2">
                                <label htmlFor="">Destinataires(vous pouvez choisir plusieurs) <span className="ms-auto"> <input type="checkbox" className="fomr-check-input" id="tous" name='tous' onChange={(e) => setTous(!tous)} /> <label htmlFor="tous" className="text-primary">Envoyer a tous</label> </span></label>
                                <Select isDisabled={tous}
                                    options={
                                        clients?.map((client) => (
                                            {
                                                value: `${client.telephone}`, label: `${client.client}(${client.telephone})`
                                            }
                                        ))
                                    }
                                    isMulti
                                    onChange={setSelectedOptions}

                                    classNamePrefix="react-select"
                                />
                            </div>
                            <textarea name="message" id="message" rows={5} cols="30"
                                placeholder="Ecrire le message ici"
                                className="form-control"

                                onChange={(e) => setSms(e.target.value)}
                            >{sms}</textarea>
                            {isloading && <div className="text-center p-2">
                                <Loading />
                            </div>}
                        </div>
                        <div className="modal-footer">
                            <button type="reset" className="btn btn-danger" data-bs-dismiss="modal" ref={ref}>Annuler</button>
                            <button type="submit" className="btn btn-success" disabled={isloading}> Envoyer</button>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    );
}

export default ModalSendSms;